import React from 'react'
import { Box } from '@machobear/design-system'

import { BlluredTextVariants, blurredTextStyle } from './blurred-text.css'

const BlurredText = ({
  children,
  variant = { size: 'regular', weight: 'strong' }
}: {
  children: React.ReactNode
  variant?: BlluredTextVariants
}) => {
  const { size, weight } = variant
  const customStyle = blurredTextStyle({ size, weight })
  return (
    <Box component="span" className={customStyle}>
      {children}
    </Box>
  )
}

export default BlurredText
